var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "preview-dialog",
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "80%",
        top: "2vh",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _vm.showType === "pdf"
            ? _c("div", [
                _c("iframe", {
                  attrs: {
                    src: _vm.newUrl,
                    width: "100%",
                    height: "762px",
                    frameborder: "0"
                  }
                })
              ])
            : _vm.showType === "docx"
            ? _c("div", { staticClass: "word-wrap" }, [
                _c("div", {
                  ref: "docxFile",
                  domProps: { innerHTML: _vm._s(_vm.docxHtml) }
                })
              ])
            : _vm.showType === "picture"
            ? _c("el-image", { attrs: { fit: "contain", src: _vm.url } }, [
                _c(
                  "div",
                  {
                    staticClass: "image-slot",
                    attrs: { slot: "error" },
                    slot: "error"
                  },
                  [_c("i", { staticClass: "el-icon-picture-outline" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "image-slot",
                    attrs: { slot: "placeholder" },
                    slot: "placeholder"
                  },
                  [
                    _vm._v("\n        加载中"),
                    _c("span", { staticClass: "dot" }, [_vm._v("...")])
                  ]
                )
              ])
            : _vm.showType === "xlsx"
            ? _c(
                "div",
                [
                  _c(
                    "el-tabs",
                    {
                      staticStyle: { height: "200px" },
                      attrs: { "tab-position": "bottom" }
                    },
                    _vm._l(_vm.tableArr, function(item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: { label: item.name },
                        domProps: { innerHTML: _vm._s(item.value) }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm.showType === "txt"
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.html) } })
            : _vm.showType === "video"
            ? _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("video", { attrs: { src: _vm.url, controls: "controls" } }, [
                  _vm._v("\n        您的浏览器不支持 video 标签。\n      ")
                ])
              ])
            : _c("div", [_vm._v("该文件类型不支持在线预览")])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-684d4d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684d4d06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/previewDialog/previewDialog.vue
// module id = null
// module chunks = 